import template from './signature-item.photo.html';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.signature-block.signature-item.photo',
    []
  )
  .component('tcSignatureItemPhoto', {
    //tc-signature-item-photo
    template,
    bindings: {
      me: '<',
      data: '<',
      disabled: '<',
    },
    controller: function (publisherManager, photoFactory, $filter, $element) {
      // Photo signature is sent as a single message via pubnub
      // that contains 2 images - person photo and rendered signature
      // so we must not exceed 30kb (15kb+15kb) for both images
      const maxFileSize = 15;

      this.inputClass = 'tc-photo-signature-input-handle';

      const getPicture = () => {
        return publisherManager.capturePhotoWithCrop({
          maxFileSize,
          width: 370,
          height: 370,
        });
      };

      this.prePicture = '/assets/icons/legacy/avatar.svg';

      const updatePicture = () => {
        getPicture().then((picture) => {
          this.prePicture = picture;
        });
      };

      if (!this.disabled) updatePicture();

      this.sign = () => {
        if (this.disabled) return;

        const signatureWidth = $element[0].querySelector(
          `.${this.inputClass}`
        ).clientWidth;

        getPicture().then((picture) => {
          this.data.pictureName = photoFactory.getTextImage(this.pictureName, {
            maxFileSize,
            width: signatureWidth,
            background: '#f2f2f2',
            align: 'left',
          });
          this.data.photoSigned = true;
          this.data.date = $filter('date')(new Date(), 'medium');
          this.data.picture = angular.copy(picture);
          this.data.ip = this.me.privateData.ip;
        });
      };

      this.reset = function () {
        if (this.disabled) return;

        this.data.photoSigned = false;
        this.pictureName = undefined;
        this.data.pictureName = null;
        this.data.picture = null;
        this.data.date = null;
        updatePicture();
      };

      this.cancel = () => {
        if (this.disabled) return;

        this.reset();
        this.data.state = 'initial';
      };
    },
  }).name;
